import classNames from 'classnames';
import SimpleSelect from 'components/SimpleSelect';
import React, { useMemo } from 'react';
import type { Currency } from 'types/account';
import styles from './CurrencySelect.module.scss';

interface Props {
  value: string;
  currencies: Array<Currency>;
  onChange: (currencyId: string) => void;
  className?: string;
  disabled?: boolean;
}

export default function CurrencySelect(props: Props) {
  const { onChange, currencies, value, className } = props;
  const containerClass = classNames(styles.container, className);

  function handleChange(newValue: string) {
    if (onChange && newValue) {
      onChange(newValue);
    }
  }

  const options = useMemo(() => {
    return currencies.map(currency => {
      return {
        value: currency.id,
        label: currency.name,
        symbol: currency.symbol,
        isoCode: currency.iso_code,
      };
    });
  }, [currencies]);

  return (
    <SimpleSelect
      value={value}
      placeholder="No currency selected"
      onChange={handleChange}
      options={options}
      className={containerClass}
      disabled={props.disabled}
    />
  );
}
